import {AfterViewInit, Component, Input, OnInit, ViewChild} from '@angular/core';
import {ModalDirective} from 'ngx-bootstrap/modal';
import {ActivatedRoute, Router} from '@angular/router';
import {NachdigalService, PersonenstammDaten} from '@nachdigal';
import {TranslateService} from '@ngx-translate/core';
import {DeleteHelperService} from '@utils-lib';
import {environment} from '../../../../environments/environment';

@Component({
    selector: 'common-ui-entwurf-loeschen',
    templateUrl: './entwurf-loeschen.component.html',
    styleUrls: ['./entwurf-loeschen.component.scss']
})
export class EntwurfLoeschenComponent implements OnInit, AfterViewInit {

    @ViewChild(ModalDirective) lgModal: ModalDirective;

    @Input()
    public context: string;

    @Input()
    public readonly = false;

    @Input()
    public imageOnly: boolean;
    public clientName: string;
    public clientNumber: string;
    public disableDelete: boolean;

    private taskId: string;

    constructor(private readonly router: Router,
                protected readonly activatedRoute: ActivatedRoute,
                private readonly nachdigalService: NachdigalService,
                private readonly translateService: TranslateService,
                private readonly deleteHelperService: DeleteHelperService) {
    }

    public ngOnInit(): void {
        const activatedRoute = this.activatedRoute.parent.snapshot;
        const client = activatedRoute.data.taskData?.nutzdaten?.personenAngaben?.antragsteller as PersonenstammDaten;
        this.clientNumber = activatedRoute.data.document?.element_of_order?.client_number;
        this.clientName = this.prepareClientName(client);
        this.taskId = activatedRoute.paramMap.get('taskId');
    }

    public ngAfterViewInit(): void {
        if (this.lgModal?.config) {
            this.lgModal.config.ignoreBackdropClick = true;
        }
    }

    public onDeleteDraft(): void {
        this.deleteHelperService.flag = true;
        this.disableDelete = true;
        this.nachdigalService.delete(this.taskId).subscribe(() => {
            this.lgModal.hide();
            this.router.navigate([environment.redirectPath]);
        }, () => {
            this.lgModal.hide();
        });
    }

    public onCancelDraft(): void {
        this.disableDelete = false;
        this.lgModal.hide();
    }

    private prepareClientName(client: PersonenstammDaten): string {
        let name = '';
        const clientInfoArray = [
            client?.nachname,
            client?.vorname,
            (this.clientNumber === '0' ? '' : this.clientNumber)
        ];

        const cleanClientInfoArray = clientInfoArray.filter(Boolean);
        if (cleanClientInfoArray.length === 0) {
            return name;
        }

        name = this.translateService.instant('COMMON_UI.ENTWURF_LOESCHEN.MESSAGEFOR');
        cleanClientInfoArray.forEach((elem, index) => {
            if (index === 0) {
                name = name + elem;
            } else {
                name = `${name}, ${elem}`;
            }
        });

        return name;
    }
}
